<p-menubar class="menu-bar">
  <ng-template pTemplate="start">
    <a id="emr-nav-text" [href]="logoLink" target="_blank">
      <img *ngIf="logoImageSrc" [src]="logoImageSrc" height="40" />
    </a>
  </ng-template>
  <ng-template pTemplate="end">
    <ng-content></ng-content>
  </ng-template>
</p-menubar>